import React, { useState } from 'react';
import { TextField, Button, Box, Typography, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ACCOUNT_INITIALIZE } from '../../store/actions'; // Replace with your actual logout action type

const ChangePasswordPage = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const org_member = useSelector((state) => state?.account?.org_member);

  const email = org_member?.email;
  const history = useHistory();
  const dispatch = useDispatch();

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    // Reset messages
    setErrorMessage('');
    setSuccessMessage('');

    if (newPassword !== confirmPassword) {
      setErrorMessage('New passwords do not match!');
      return;
    }

    const payload = {
      email: email,
      currentPassword: currentPassword,
      newPassword: newPassword,
    };

    try {
      const response = await fetch(
        'https://api.projectivetech.com/organization/change-password/',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        setSuccessMessage('Password changed successfully!');

        // Clear the input fields
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');

        // Logout the user
        dispatch({
          type: ACCOUNT_INITIALIZE,
          payload: {
            isLoggedIn: false,
            user: null,
            token: null,
            org: null,
          },
        });

        // Redirect to login page
        setTimeout(() => {
          history.push('/login');
        }, 2000);
      } else {
        const data = await response.json();
        setErrorMessage(data.message || 'Failed to change password.');
      }
    } catch (error) {
      setErrorMessage('An error occurred. Please try again.');
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 500,
        margin: '50px auto',
        padding: '30px',
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e0e0e0',
      }}
    >
      <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
        Change Password
      </Typography>
      {errorMessage && (
        <Typography color="error" align="center" sx={{ marginBottom: '16px' }}>
          {errorMessage}
        </Typography>
      )}
      {successMessage && (
        <Typography color="primary" align="center" sx={{ marginBottom: '16px' }}>
          {successMessage}
        </Typography>
      )}
      <form onSubmit={handlePasswordChange}>
        <TextField
          fullWidth
          label="Current Password"
          type={showCurrentPassword ? 'text' : 'password'}
          margin="normal"
          variant="standard"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          required
          sx={{ marginBottom: '20px' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  edge="end"
                >
                  {showCurrentPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          fullWidth
          label="New Password"
          type={showNewPassword ? 'text' : 'password'}
          margin="normal"
          variant="standard"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          sx={{ marginBottom: '20px' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  edge="end"
                >
                  {showNewPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          fullWidth
          label="Confirm New Password"
          type={showConfirmPassword ? 'text' : 'password'}
          margin="normal"
          variant="standard"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          sx={{ marginBottom: '20px' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  edge="end"
                >
                  {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ padding: '10px' }}>
          Change Password
        </Button>
      </form>
    </Box>
  );
};

export default ChangePasswordPage;
